export const setDocumentDirectionPerLocale = (locale) => {
  document.dir = locale === "ar" ? "rtl" : "ltr";
};

export const setDocumentLang = (lang) => {
  document.documentElement.lang = lang;
};
